import { Directive, ElementRef, Renderer2, AfterViewInit, OnDestroy } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { FilterHelpDialogComponent } from '../../modal-dialog/filter-help/filter-help-dialog.component';

@Directive({
    selector: 'p-columnFilter',
    standalone: false
})
export class ColumnFilterHelpDirective implements AfterViewInit, OnDestroy {
    private helpIcon: HTMLElement;
    private clickListener: () => void;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private dialogService: DialogService
    ) {}

    ngAfterViewInit() {
        // Listen on document for when filter overlay appears
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node instanceof HTMLElement && node.classList?.contains('p-datatable-filter-overlay')) {
                        setTimeout(() => this.addHelpIconToOverlay(), 50);
                    }
                });
            });
        });
        
        observer.observe(document.body, { childList: true, subtree: true });
    }

    private addHelpIconToOverlay() {
        // Find the filter button bar in the overlay
        const buttonBar = document.querySelector('.p-datatable-filter-buttonbar');
        
        if (!buttonBar) {
            return;
        }
        
        if (buttonBar.querySelector('.ef-filter-help-icon')) {
            return; // Already added
        }

        // Create help icon
        this.helpIcon = this.renderer.createElement('i');
        this.renderer.addClass(this.helpIcon, 'pi');
        this.renderer.addClass(this.helpIcon, 'pi-question-circle');
        this.renderer.addClass(this.helpIcon, 'ef-filter-help-icon');
        this.renderer.setAttribute(this.helpIcon, 'title', 'Filter Help');
        
        // Style the icon for button bar placement
        this.renderer.setStyle(this.helpIcon, 'cursor', 'pointer');
        this.renderer.setStyle(this.helpIcon, 'color', '#6c757d');
        this.renderer.setStyle(this.helpIcon, 'font-size', '1.3rem');
        this.renderer.setStyle(this.helpIcon, 'margin-left', '0.5rem');
        this.renderer.setStyle(this.helpIcon, 'transition', 'color 0.2s');
        this.renderer.setStyle(this.helpIcon, 'display', 'inline-flex');
        this.renderer.setStyle(this.helpIcon, 'align-items', 'center');
        
        // Add click listener
        this.clickListener = this.renderer.listen(this.helpIcon, 'click', (e) => this.showHelp(e));
        
        // Add hover effect
        this.renderer.listen(this.helpIcon, 'mouseenter', () => {
            this.renderer.setStyle(this.helpIcon, 'color', '#495057');
        });
        this.renderer.listen(this.helpIcon, 'mouseleave', () => {
            this.renderer.setStyle(this.helpIcon, 'color', '#6c757d');
        });
        
        // Insert the icon at the end of the button bar
        this.renderer.appendChild(buttonBar, this.helpIcon);
        console.log('Help icon added to button bar');
    }

    private showHelp(event: Event) {
        event.stopPropagation();
        event.preventDefault();
        const ref = this.dialogService.open(FilterHelpDialogComponent, {
            header: 'Column Filter Help',
            width: '600px',
            modal: true
        });
    }

    ngOnDestroy() {
        if (this.helpIcon && this.helpIcon.parentNode) {
            this.renderer.removeChild(this.helpIcon.parentNode, this.helpIcon);
        }
    }
}
